import { AccordionSummary, Grid, Typography } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import EditIcon from '@material-ui/icons/Edit';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import VisibilityIcon from '@material-ui/icons/Visibility';
import MaterialTable from 'material-table';
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../../../services/api';
import { findPermission } from '../../../../services/auth';
import useStyles from '../style';
import Loading from '../../../../components/Loading';
import { FilterStatusHeader } from './FilterStatusHeader';
import { canShowEdit } from '../../../../utils/functions';

const normalizeModoEnvioLabel = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  if (normalized === '1' || normalized === 'whatsapp') {
    return 'WhatsApp';
  }
  if (normalized === '2' || normalized === 'email' || normalized === 'e-mail') {
    return 'E-mail';
  }
  return value || '';
};

export function ContactAssGroup({ providerId, isEditing, fornecedorId }) {
  const classes = useStyles();

  const [contactGroups, setContactGroups] = useState([]);
  const [status, setStatus] = useState('ativo');
  const [isLoading, setLoading] = useState(false);
  const memoizedTableAss = useMemo(
    () => (
      <MaterialTable
        localization={{
          body: {
            emptyDataSourceMessage: <span></span>,
          },
        }}
        className={classes.table}
        options={{
          showTitle: false,
          search: false,
          toolbar: false,
          headerStyle: {
            backgroundColor: '#F5F5F5',
            textTransform: 'none',
            fontSize: '15px',
          },
          filtering: true,
          paging: false,
        }}
        onRowClick={(event, rowData) => {
          if(!!findPermission(2730, 'Alterar') && canShowEdit()) {
            window.location.href = window.location.origin + `/app/fornecedor/${providerId}/grupo-contato-ass/${rowData.fornecedorContatoAssinaturaId}/editar`
          }
        }}
        title="Multiple Actions Preview"
        columns={[
          {
            title: 'Nome',
            field: 'nome',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 10px',
            },
          },
          {
            title: 'Status',
            field: 'status',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Modo de envio',
            field: 'modoEnvio',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
            render: (rowData) =>
              normalizeModoEnvioLabel(rowData?.modoEnvio || rowData?.ModoEnvio || ''),
          },
          {
            title: 'Ações',
            field: 'actions',
            headerStyle: {
              textAlign: 'center',
            },
            cellStyle: {
              fontSize: '13px',
              textAlign: 'center',
              padding: '8px 16px',
            },
            filtering: false,
            sorting: false,
            disableClick: true,
            render: (rowData) => (
              <>
                {!!findPermission(2730, 'Consultar') && (
                  <Link
                    className={classes.buttonVisualize}
                    to={
                      {pathname: `/app/fornecedor/${providerId}/grupo-contato-ass/${rowData.fornecedorContatoAssinaturaId}`,
                      state: {fornecedorContatoAssinaturaId: rowData.fornecedorContatoAssinaturaId }}
                    }

                  >
                    <VisibilityIcon style={{ fontSize: 30, color: '#4AAF05' }} />
                  </Link>
                )}
                {!!findPermission(2730, 'Alterar') && canShowEdit() && (
                  <Link
                    className={classes.buttonEdit}
                    to={
                      {
                        pathname:`/app/fornecedor/${providerId}/grupo-contato-ass/${rowData.fornecedorContatoAssinaturaId}/editar`,
                        state: {fornecedorContatoAssinaturaId: rowData.fornecedorContatoAssinaturaId }
                      }
                    }
                  >
                    <EditIcon style={{ fontSize: 30, color: '#FB8832' }} />
                  </Link>
                )}
              </>
            ),
          },
        ]}
        data={contactGroups}
      />
    ),
    [contactGroups],
  );

  const fetchContactInfo = async () => {
    setLoading(true);
    // API espera enum: Ativo=1, Inativo=0. "Todos" = não envia status.
    const statusParam =
      status === 'ativo' ? '1' : status === 'inativo' ? '0' : '';
    const query = statusParam
      ? `fornecedorId=${fornecedorId}&status=${statusParam}`
      : `fornecedorId=${fornecedorId}`;
    const res = await api.get(
      `FornecedoresContatosAssinaturas/ConsultarFornecedorId?${query}`,
    );
    const msg = res.data.resposta?.[0]?.message ?? '';
    const isSemContatoAssinatura =
      msg === 'Valor não encontrado' ||
      msg.includes('Nenhum contato para assinatura');
    if (
      res.data.resposta?.[0]?.key === 'Notificacao' ||
      res.data.resposta?.[0]?.key === '' ||
      isSemContatoAssinatura
    ) {
      setContactGroups([]);
    } else {
      setContactGroups(
        res.data.resposta.map((contact) => ({
          ...contact,
          telefone:
            (contact?.ddd ? `(${contact?.ddd}) ` : '') +
            `${contact?.telefone}`,
        })),
      );
    }
    setLoading(false);
  };

  const loadAuxiliaryData = async () => {
    try {
      await fetchContactInfo();
    } catch (error) {
      console.error('Erro ao carregar contatos:', error);
    }
  };

  useEffect(() => {
    if (providerId) {
      loadAuxiliaryData();
    }
  }, [providerId, status]);

  return (
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
        <Typography className={classes.heading}>Contatos que podem assinar contratos</Typography>
      </AccordionSummary>

      <AccordionDetails className={classes.details}>
        <Grid container>
          <Grid item xs={12} className={classes.registerBtn}>
            <FilterStatusHeader
              fetchFunc={() => fetchContactInfo()}
              status={status}
              setStatus={setStatus}
            />
            {isEditing && !!findPermission(2730, 'Cadastrar') && (
              <Link
                className={classes.button}
                to={`/app/fornecedor/${providerId}/cadastrar-grupo-contato-ass`}
              >
                Novo Item
              </Link>
            )}
          </Grid>

          {isLoading ? (
            <Loading />
          ) : (
            <Grid item xs={12}>
              {memoizedTableAss}
            </Grid>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
